module.exports = __webpack_public_path__ + "img/comment-summary.339a7a53.webp";